/**
 * Importe tal como se muestra al usuario.
 * Comisión: el signo se conserva.
 * Retrocomisión: se invierte el signo del valor almacenado (5 → -5, -5 → +5).
 */
export function importeRetribucionParaMostrar(
  importe: number | null | undefined,
  esRetrocomision: boolean,
): number | null | undefined {
  if (importe == null) {
    return importe;
  }
  return esRetrocomision ? -importe : importe;
}

export function esPrefijoRetrocomision(prefijo?: string): boolean {
  return prefijo === "Retrocomisión";
}

export type LiquidacionRetribucionRow = {
  Comision?: number | null;
  Retrocomision?: number | null;
  ComisionEfectiva?: number | null;
  RetrocomisionEfectiva?: number | null;
};

export function esLiquidacionRetrocomision(row: LiquidacionRetribucionRow): boolean {
  return row.RetrocomisionEfectiva != null || row.Retrocomision != null;
}

export function comisionEfectivaLiquidacion(row: LiquidacionRetribucionRow): number | null | undefined {
  return row.ComisionEfectiva ?? row.Comision;
}

export function retrocomisionEfectivaLiquidacion(row: LiquidacionRetribucionRow): number | null | undefined {
  return row.RetrocomisionEfectiva ?? row.Retrocomision;
}

/** Importe con signo para acumular base imponible (alineado con ResolveImporteEfectivo del backend). */
export function importeLineaLiquidacionParaBaseImponible(row: LiquidacionRetribucionRow): number {
  if (esLiquidacionRetrocomision(row)) {
    return -(retrocomisionEfectivaLiquidacion(row) ?? 0);
  }
  return comisionEfectivaLiquidacion(row) ?? 0;
}
